//
// Copyright (c) 2011-2022 by Curalate, Inc.
//

import moment from 'moment-timezone';

import { FacebookAudienceMetricsActions } from '@facebook/actions/facebookAudienceMetricsActions';
import {
  FacebookPageAudienceGenderOptions,
  FacebookPageAudienceLocationOptions,
} from '@facebook/constants/facebookAudienceConstants';
import { FACEBOOK_AUDIENCE_ACTIONS } from '@facebook/constants/facebookConstants';
import { IFacebookAudienceMetrics } from '@facebook/models/facebookStateModel';

const initialState: IFacebookAudienceMetrics = {
  audienceStats: {
    bubbleStats: undefined,
    comparisonBubbleStats: undefined,

    graphStats: [],
    fansByGenderGraphStats: {
      [FacebookPageAudienceGenderOptions.MALE]: 0,
      [FacebookPageAudienceGenderOptions.FEMALE]: 0,
      [FacebookPageAudienceGenderOptions.UNSPECIFIED]: 0,
    },
    fansByAgeGraphStats: {
      [FacebookPageAudienceGenderOptions.ALL]: [],
      [FacebookPageAudienceGenderOptions.MALE]: [],
      [FacebookPageAudienceGenderOptions.FEMALE]: [],
      [FacebookPageAudienceGenderOptions.UNSPECIFIED]: [],
    },
    fansByLocationGraphStats: {
      [FacebookPageAudienceLocationOptions.CITIES]: [],
      [FacebookPageAudienceLocationOptions.COUNTRIES]: [],
    },
  },
  audienceGraphSettings: {
    fansByAgeOption: FacebookPageAudienceGenderOptions.ALL,
    fansByLocationOption: FacebookPageAudienceLocationOptions.COUNTRIES,
  },
  dateRange: {
    alias: 'last7Days',
    startDate: moment().subtract(6, 'days').toDate(),
    endDate: moment().toDate(),
  },
  errors: {
    fetchAudienceStatsError: undefined,
  },
  flags: {
    isFetchingAudienceStats: false,
  },
};

export default function FacebookAudienceMetricsReducer(
  state: IFacebookAudienceMetrics = initialState,
  action: FacebookAudienceMetricsActions,
): IFacebookAudienceMetrics {
  switch (action.type) {
    case FACEBOOK_AUDIENCE_ACTIONS.GET_AUDIENCE_STATS: {
      return {
        ...state,
        errors: {
          ...state.errors,
          fetchAudienceStatsError: undefined,
        },
        flags: {
          ...state.flags,
          isFetchingAudienceStats: true,
        },
      };
    }
    case FACEBOOK_AUDIENCE_ACTIONS.RECEIVE_AUDIENCE_STATS_SUCCEEDED: {
      return {
        ...state,
        audienceStats: action.audienceStats,
        flags: {
          ...state.flags,
          isFetchingAudienceStats: false,
        },
      };
    }
    case FACEBOOK_AUDIENCE_ACTIONS.RECEIVE_AUDIENCE_STATS_FAILED: {
      return {
        ...state,
        errors: {
          ...state.errors,
          fetchAudienceStatsError: action.error,
        },
        flags: {
          ...state.flags,
          isFetchingAudienceStats: false,
        },
      };
    }
    case FACEBOOK_AUDIENCE_ACTIONS.UPDATE_AGE_GENDER_OPTION: {
      return {
        ...state,
        audienceGraphSettings: {
          ...state.audienceGraphSettings,
          fansByAgeOption: action.ageGenderOption,
        },
      };
    }
    case FACEBOOK_AUDIENCE_ACTIONS.UPDATE_LOCATION_OPTION: {
      return {
        ...state,
        audienceGraphSettings: {
          ...state.audienceGraphSettings,
          fansByLocationOption: action.locationOption,
        },
      };
    }
    case FACEBOOK_AUDIENCE_ACTIONS.UPDATE_DATE_RANGE: {
      return {
        ...state,
        dateRange: action.dateRange,
      };
    }
    default:
      return state;
  }
}
